import ReactPaginate from 'react-paginate';
import { Flex, Text, Box, Select, Button } from '@chakra-ui/react';
import { IterationComponent } from '@components/functionComponent';
import { ChevronRightIcon, ChevronLeftIcon } from '@assets/icons/index';

export default function Pagination({
    fontSize = 'inherit',
    onChangeLimit = () => {},
    limit = 10,
    totalData = 0,
    onPageChange = () => {},
    pageCount = 1,
    page = 1,
    ...props
}) {
    return (
        <Flex justifyContent={'space-between'} {...props}>
            <Flex gap={'12px'} alignItems={'center'} fontSize={fontSize}>
                <Text>Menampilkan </Text>
                <Select
                    defaultValue={Math.min(limit, 10)}
                    minW={'100px'}
                    onChange={(e) => onChangeLimit(e.target.value)}
                    fontSize={fontSize}
                >
                    <IterationComponent
                        arr={[limit ?? 0, 10, 30, 50, 70, 100]}
                        render={(item) => <option value={item}>{item}</option>}
                    />
                </Select>
                <Text minW={'fit-content'}> dari total {totalData} Data</Text>
            </Flex>

            <Box fontSize={fontSize}>
                <ReactPaginate
                    onPageChange={onPageChange}
                    pageRangeDisplayed={3}
                    marginPagesDisplayed={1}
                    pageCount={pageCount}
                    forcePage={page - 1}
                    previousLabel={
                        <Button
                            variant={'plain'}
                            gap="8px"
                            alignItems="center"
                            disabled={page - 1 == 0}
                            fontSize={fontSize}
                        >
                            <ChevronLeftIcon />
                            <Text>Prev</Text>
                        </Button>
                    }
                    nextLabel={
                        <Button
                            variant={'plain'}
                            gap="8px"
                            alignItems="center"
                            disabled={page >= pageCount}
                            fontSize={fontSize}
                        >
                            <Text>Next</Text>
                            <ChevronRightIcon />
                        </Button>
                    }
                    containerClassName="pagination"
                    activeClassName="active"
                    pageClassName="page-item"
                    pageLinkClassName="page-link"
                    breakLinkClassName="page-link"
                />
            </Box>
        </Flex>
    );
}
